import { adapterAction } from '@mainmatter/ember-api-actions';

import ApplicationAdapter from 'register-partners-js/adapters/application';

export default class KycAdapter extends ApplicationAdapter {
  pathForType() {
    return 'kyc';
  }

  async regenerateKycFromToken(stakeholder_id) {
    return await adapterAction(this, 'kyc', {
      method: 'POST',
      data: {
        data: {
          type: 'kyc',
          relationships: { stakeholder: { data: { id: stakeholder_id } } },
        },
      },
    });
  }
}
